// extracted by mini-css-extract-plugin
export const artists = "ArtistsList-module--artists--1a0CL";